import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { Configuration, PmsApi, DashboardResponseDTO } from "@inosio/payments-sdk";
import { selectCurrentUser } from "../../../shared/sagas/auth/authSlice";
import { getDashboardData, setDashboardData, getDashBoardDataFailed } from "./pmDashboardSlice";
import {IpaUserExtended} from "../../../shared/sagas/auth/authSlice";

const { REACT_APP_IPA_BASE_PATH } = process.env;
const apiConfig = new Configuration({ basePath: REACT_APP_IPA_BASE_PATH });

export function requestGetDashboardData(
    access_token: string,
    pm_uuid: string,
    startDate?: string,
    endDate?: string,
) {
    apiConfig.accessToken = access_token;
    const ipaPmAPI = new PmsApi(apiConfig);
    return ipaPmAPI.getDashboardData(pm_uuid, startDate, endDate);
}

export function* handleGetDashboardData(action: any) {
    try {
        const currentUser:IpaUserExtended= yield select(selectCurrentUser);
        const response: AxiosResponse<DashboardResponseDTO> = yield call(
            requestGetDashboardData,
            currentUser.accessToken,
            currentUser.currentProfile.uuid,
            action.payload.startDate,
            action.payload.endDate,
        );
        const { data } = response;
        yield put(setDashboardData(data));
    } catch (error: any) {
        yield put(getDashBoardDataFailed({ message: error?.response?.data?.message }))
    }
}

export function* pmDashboardDataSaga() {
    yield takeLatest(
        getDashboardData.type,
        handleGetDashboardData
    );
}
